import { ExternalLink } from "lucide-react";
import { NIBIRU_USDC_ADDRESS, BRIDGE_CHAINS } from "./bridgeConstants";

const ETH_USDC = BRIDGE_CHAINS.find((c) => c.id === "ethereum").usdcAddress;

export const STARGATE_URL =
  `https://stargate.finance/?` +
  `srcChain=ethereum&srcToken=${ETH_USDC}` +
  `&dstChain=nibiru&dstToken=${NIBIRU_USDC_ADDRESS}`;

/**
 * Stargate now blocks iframing its app (CSP frame-ancestors, enforced on
 * their end to protect the in-app wallet-connect flow) — so instead of
 * embedding it, we hand off to the real site in a new tab, pre-filled to
 * USDC.e on Nibiru.
 */
export default function StargatePanel() {
  return (
    <div className="flex flex-col items-center justify-center gap-4 px-8 py-10 text-center">
      <p className="text-[13px] text-[#666]">
        Opens Stargate in a new tab, pre-filled to bridge USDC into Nibiru.
      </p>
      <a
        href={STARGATE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-2 bg-gradient-to-b from-[#5b1deec0] to-[#5b1dee] text-white text-[14px] font-semibold rounded-[12px] px-6 py-3 hover:opacity-90 transition-opacity"
      >
        Open Stargate
        <ExternalLink size={16} />
      </a>
    </div>
  );
}
